"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unmanaged = unmanaged;
const decrementPendingClassMetadataCount_1 = require("../actions/decrementPendingClassMetadataCount");
const buildUnmanagedMetadataFromMaybeClassElementMetadata_1 = require("../calculations/buildUnmanagedMetadataFromMaybeClassElementMetadata");
const injectBase_1 = require("./injectBase");
function unmanaged() {
    const updateMetadata = (0, buildUnmanagedMetadataFromMaybeClassElementMetadata_1.buildUnmanagedMetadataFromMaybeClassElementMetadata)();
    return (0, injectBase_1.injectBase)(updateMetadata, decrementPendingClassMetadataCount_1.decrementPendingClassMetadataCount);
}
//# sourceMappingURL=unmanaged.js.map